import React from 'react';
import ShowsTile from 'screens/Shows/components/ShowsTile';
import _ from 'lodash';

const ShowsTiles = ({ items, breakpoint }) =>
  items.map((item, idx) => (
    <ShowsTile key={`shows-tile-${_.get(item, '@id', idx)}`} item={item} breakpoint={breakpoint} />
  ));

export default ShowsTiles;
